import ReactGA from 'react-ga';

const trackingId = 'UA-157124467-1';
ReactGA.initialize(trackingId);

export const setPage = url => {
  ReactGA.set({ page: url });
  ReactGA.pageview(url);
};
